module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/4wLwk9/tc-custom/9781460308981.jpg?1705026083369",
      "alt": "This image is the cover for the book Beg for Mercy, The Mercy Hollings Novels"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Beg for Mercy, The Mercy Hollings Novels\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("I've never been certain I'm human "), _c('br'), _c('br'), _vm._v("Oh, the X-rays and blood tests are normal, and most people have no reason to suspect I'm more than I appear to be. But if I tell you to do something? You do it -- no ifs, ands or buts. "), _c('br'), _c('br'), _vm._v("I call my power the 'press.' "), _c('br'), _c('br'), _vm._v("My name  is Mercy Hollings, and if you think that having the power to control people makes my life easy, you're dead wrong. "), _c('br'), _c('br'), _vm._v("Because when I get angry, everyone around me is at risk -- Sukey, my friend who has frightening taste in men; my clients, who, ironically, come to me for help; my neighbors, who regard me as a loner; and Sam, a man who wants to know my darkest secret. "), _c('br'), _c('br'), _vm._v("I have hurt people in the past, and I don't want that to happen again. But now a powerful stranger is threatening the new life that I've made for myself. "), _c('br'), _c('br'), _vm._v("And I'm afraid my anger is taking over.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Toni Andrews\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin Enterprises\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0